import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getActivations(filters: any) {
  const params = new URLSearchParams();

  if (filters.user_id) params.set('user_id', filters.user_id);
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  if (filters.rol_id) params.set('rol_id', filters.rol_id);

  const response = await axios.get(
    `${API_URL}reports/activation?sort=id&${params.toString()}`
  );
  const data = response.data.doc.data;
  return data;
}

interface ReportFilters {
  code?: string;
  offer_id?: number;
  init_date?: string;
  end_date?: string;
  user_id?: number;
}

export async function downloadPDF(filters: ReportFilters) {
  const date = new Date().toISOString().split('T')[0];
  const params = new URLSearchParams({ sort: 'id' });

  if (filters.user_id && filters.user_id !== 0)
    params.append('user_id', filters.user_id.toString());
  if (filters.code) params.append('code', filters.code);
  if (filters.offer_id && filters.offer_id !== 0)
    params.append('offer_id', filters.offer_id.toString());
  if (filters.init_date) params.append('init_date', filters.init_date);
  if (filters.end_date) params.append('end_date', filters.end_date);

  try {
    const response = await axios.get(
      `${API_URL}reports/activation/document/pdf?${params.toString()}`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ACTIVACION-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error: any) {
    const errorData = await error.response?.data?.text?.();
    return errorData ? JSON.parse(errorData) : { message: 'Error inesperado' };
  }
}

export async function getSelectUser(type: number, noAuto: boolean = true) {
  const params = new URLSearchParams();

  if (!isNaN(type) && type !== 0) {
    params.set('rol_id', type.toString());
  }

  const response = await axios.get(
    `${API_URL}reports/users?${params.toString()}`
  );
  const data = response.data.data || [];

  let dataSelect = data.map((row: any) => ({
    ...row,
    label: row.name,
    value: row.id,
  }));

  if (!noAuto) {
    dataSelect = dataSelect.filter(
      (row: any) => row.name?.toLowerCase() !== 'automática'
    );
  }

  return dataSelect;
}

export async function downloadExcel(filters: any) {
  const date = new Date().toISOString().split('T')[0];

  const params = new URLSearchParams();

  if (filters.user_id) params.append('user_id', filters.user_id.toString());
  if (filters.init_date) params.append('init_date', filters.init_date);
  if (filters.end_date) params.append('end_date', filters.end_date);

  try {
    const response = await axios.get(
      `${API_URL}reports/activation/document/excel?${params.toString()}`,
      { responseType: 'blob' }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ACTIVACION-${date}.xlsx`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);

    return true;
  } catch (error: any) {
    if (error.response?.data instanceof Blob) {
      const errorText = await error.response.data.text();
      return JSON.parse(errorText);
    }
    return { message: 'Error inesperado' };
  }
}
